import { ExternalLink, Rocket } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'

type FramerPublishResult = {
  deployment: {
    deploymentId: string
    previewUrl: string | null
  }
  message: string
}

type Props = {
  result: FramerPublishResult | null | undefined
}

export function FramerPublishCard({ result }: Props) {
  const t = useTranslation()

  if (!result) return null

  return (
    <div className="my-1.5 rounded-xl border border-border bg-card p-3">
      <div className="flex items-start gap-2.5">
        <div className="flex items-center justify-center size-7 rounded-md bg-primary/10 shrink-0">
          <Rocket className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium text-card-foreground">
              {t('agent.tools.framer.publishTitle')}
            </p>
            <span className="text-[10px] font-medium px-1.5 py-0.5 rounded-md bg-primary/10 text-primary uppercase tracking-wide">
              {t('agent.tools.framer.publishPreview')}
            </span>
          </div>
          <p className="text-xs text-muted-foreground mt-0.5">
            {result.message || t('agent.tools.framer.publishMessage')}
          </p>
          <div className="mt-2 flex items-center gap-1.5 text-[11px] text-muted-foreground">
            <span className="font-medium">{t('agent.tools.framer.publishDeploymentIdLabel')}:</span>
            <code className="font-mono bg-muted px-1.5 py-0.5 rounded truncate">
              {result.deployment.deploymentId}
            </code>
          </div>
          {result.deployment.previewUrl ? (
            <a
              href={result.deployment.previewUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-1 text-xs text-primary hover:underline"
            >
              {t('agent.tools.framer.publishOpenPreview')}
              <ExternalLink className="w-3 h-3" />
            </a>
          ) : (
            <p className="mt-2 text-[11px] text-muted-foreground italic">
              {t('agent.tools.framer.publishOpenDashboard')}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
